<div class="mobile-shell">

    <!-- Header -->
    <main class="screen-content">
      <div class="content">
  
        <!-- Important -->
        <div class="important">
          <i class="pi pi-exclamation-triangle warn-icon"></i>
    
          <div class="important-text">
            <div class="important-title">Important</div>
            <div class="important-desc">
              The sender name must match your MoMo registered account.
              Mismatched names will result in a failed transaction.
            </div>
          </div>
    
          <i class="pi pi-times close"></i>
        </div>
    
        <!-- Summary -->
        <div class="card">
    
          <div class="row">
            <span>Bank location</span>
            <span class="value">{{ instantBankTransferService.data().bankLocation}}</span>
          </div>
    
          <div class="row">
            <span>Purpose of funds</span>
            <span class="value">{{instantBankTransferService.data().purpose}}</span>
          </div>
    
          <div class="row">
            <span>Currency type</span>
            <span class="value">{{ authService.quoteDetails()?.data?.sourceCurrency}}</span>
          </div>
    
          <div class="row">
            <span>Exchange rate</span>
            <span class="value">1 {{authService.quoteDetails()?.data?.creditedCurrency}} = {{authService.quoteDetails()?.data?.sourceCurrency}} {{authService.quoteDetails()?.data?.fxRate}}</span>
          </div>
    
          <div class="row">
            <span>Conversion</span>
            <span class="value">{{authService.quoteDetails()?.data?.sourceAmount}} x {{authService.quoteDetails()?.data?.fxRate}} = {{authService.quoteDetails()?.data?.creditedAmount}}</span>
          </div>
    
          <div class="row">
            <span>Estimated time</span>
            <span class="value">{{authService.quoteDetails()?.data?.expiresAt}}</span>
          </div>
    
          <div class="total">
            <span>Total cost</span>
            <strong>{{instantBankTransferService.data().sourceCurrency}} {{data.cost}}</strong>
          </div>
    
          <div class="get">
            <span>You’ll get</span>
            <strong>{{authService.quoteDetails()?.data?.creditedCurrency}} {{authService.quoteDetails()?.data?.creditedAmount}}</strong>
          </div>
    
        </div>
    
        <!-- Info -->
        <div class="info">
          <i class="pi pi-info-circle"></i>
          <span>
            The exchange rate will be locked once you confirm the transfer.
          </span>
        </div>
  
        <div class="alert-overlay" *ngIf="showAlert">
          <p-message severity="error" styleClass="exchange-alert-message">
        
            <ng-template pTemplate>
              <div class="exchange-alert">
        
                <div class="alert-icon-wrap">
                  <i class="pi pi-exclamation-triangle alert-icon"></i>
                </div>
        
                <div class="alert-text">
                  <div>Your quoted exchange rate has expired.</div>
                  <div>Please refresh.</div>
                </div>
        
                <button
                  type="button"
                  class="alert-close"
                  aria-label="Close alert"
                  (click)="closeAlert()"
                >
                  <i class="pi pi-times"></i>
                </button>
              </div>
            </ng-template>
          </p-message>
        </div>
        
      </div>
  
    </main>
          <!-- Buttons -->
    <div *ngIf="!showAlert">
      <footer class="screen-footer">
        <button pButton label="CONFIRM" class="confirm-btn" (click)="goConfirm()"></button>
        <button pButton label="EDIT" class="edit-btn" (click)="goEdit()"></button>  
      </footer>  
      
    </div> 
  
    <div *ngIf="showAlert">
      <footer class="screen-footer">
        <button pButton label="REFRESH" class="confirm-btn" (click)="goRefresh()"></button>
      </footer>      
    </div>   
  
  </div>